import * as React from 'react'
import 'bit-ui_component_lib-b2b/dist/index.css'
import './pba.css'
import 'piral/polyfills'
import { render } from 'react-dom'
import LangAndSentryWrapper from './LangAndSentryWrapper'

render(<LangAndSentryWrapper />, document.querySelector('#app'))
